export const RESOLUTIONS = {
    SD: {
        minHeight: 1,
        minWidth: 1,
    },
    HD: {
        minHeight: 720,
        minWidth: 1280,
    },
    UHD: {
        minHeight: 2160,
        minWidth: 3840,
    },
};
export function supportsUhd(resolution) {
    return resolution.width >= RESOLUTIONS.UHD.minWidth && resolution.height >= RESOLUTIONS.UHD.minHeight;
}
export function supportsHd(resolution) {
    return resolution.width >= RESOLUTIONS.HD.minWidth && resolution.height >= RESOLUTIONS.HD.minHeight;
}
//# sourceMappingURL=resolutions.js.map